import {
    Kvalitettype,
    VegobjektEgenskapKvalitetAttributt,
} from '@/domain/vegobjekter/Vegobjekt';
import { WKTObject } from '@/domain/WKTObject';
import type {
    Geometri as ApiGeometri,
    GeometriKvalitet as ApiGeometriKvalitet,
} from '@/generated/nvdb/vegobjekter/models';

export function transformGeometri(data: null | undefined): null;
export function transformGeometri(data: ApiGeometri): WKTObject;
export function transformGeometri(
    data: ApiGeometri | null | undefined
): WKTObject | null {
    return data
        ? new WKTObject(data.srid, data.wkt, data.egengeometri, data.forenklet)
        : null;
}

export function transformKvalitet(
    kvalitet: Record<string, number | string> | ApiGeometriKvalitet
): VegobjektEgenskapKvalitetAttributt[] {
    return Object.entries(kvalitet)
        .filter((entry): entry is [string, number | string] => entry[1] != null)
        .map(
            ([field, value]) =>
                new VegobjektEgenskapKvalitetAttributt(
                    field,
                    (Kvalitettype as Record<string, string>)[field],
                    value
                )
        );
}
